module.exports = __webpack_public_path__ + "static/media/TotalScan.a2a27522.svg";